module.exports = __webpack_public_path__ + "img/kachel-ZAHNMUND_ALOEVERAZAHNCREME.5d4ae127.png";